export default {
  SET_LOADING(state, payload) {
    state.loading = payload;
  },
  SET_LIST_PRODUCTS(state, payload) {
    state.listProducts = payload.opciones.map((item) => ({
      ...item,
      code: item.valor
    }));
    state.pagination = {
      items: Number.parseInt(payload.totalElementos, 10),
      pages: Number.parseInt(payload.totalPaginas, 10)
    };
  },
};
